import './profileHeader.css';
import { CiLocationOn } from 'react-icons/ci';
import { TfiEmail } from 'react-icons/tfi';
import { FaFacebook } from "react-icons/fa6";
import { LiaWhatsapp } from "react-icons/lia";
import { BsTelegram, BsTwitter } from "react-icons/bs";
import { CiInstagram } from "react-icons/ci";
import { CiLinkedin } from "react-icons/ci";


import Stars from '../../stars rate/Stars';
import { useFetchData } from '../../../hooks/useFetchData';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { Link } from 'react-router-dom';
import { CircularProgressbar } from 'react-circular-progressbar';

const ProfileHeader = () => {
  const {auth} = useAuthContext();
  const {data,loading,error} = useFetchData("mandoub/leveldata?id="+auth.user._id,[auth]);
  console.log("data is",data);
  const {data: toPay} = useFetchData("mandoub/to-pay?id="+auth.user?._id,[auth]);
  const {data: stats} = useFetchData("mandoub/honeyTransaction");
  const {data: level} = useFetchData("mandoub/leveldata?id="+auth?.user._id);

  const platformIcons = {
    facebook: <FaFacebook />,
    whatsapp: <LiaWhatsapp />,
    telegram: <BsTelegram />,
    instagram: <CiInstagram />,
    twitter: <BsTwitter />,
    linkedin: <CiLinkedin />
  };

  
  return (
    <div className="profile-header">
      <div className="profile-top-section">
        <img src={`${auth?.user.cover? process.env.REACT_APP_UPLOADS_DIR+auth?.user.cover : '/img/banner.avif'}`} className="banner" alt="إيما سميث" />
        <div className="df jc-sb profile-img-container md-df-c w-11/12">
          <div className="df-c ">
            <div className='profile-img'>
              <img src={`${auth?.user.img? process.env.REACT_APP_UPLOADS_DIR+auth?.user.img : '/img/default.png'}`} alt="" />
            </div>
            <div className="df-c g0">
              <div className="profile-name bold-1">{auth?.user.fullName}</div>
              <div className="text df"><TfiEmail /> {auth?.user.email}</div>
              <Stars number={5} />
            </div>
          </div>
          <div className="profile-stats df">
            <div className="total-deliv trans ta-c">
              <div className="df total bold-1"> { auth?.user.mousel }ر.ي</div>
              إجمالي المبيعات في هذا الشهر
            </div>
            <div className="total-deliv bordered ta-c">
              <div className="df total bold-1"> <img className='!w-14 aspect-square' src="https://assets.streamlinehq.com/image/private/w_240,h_240,ar_1/f_auto/v1/icons/illustrations-multicolor/rewards/medals/medal-like-badge-2zhqpxqk93g7le1w7yiksh.png?_a=DAJFJtWIZAA0" /> {stats?.data.rank}</div>
              الترتيب هذا الأسبوع
            </div>
            <div className="total-deliv trans ta-c">
              <div className="df total bold-1"><img className='!w-14 aspect-square' src="https://www.pngmart.com/files/23/Sales-Icon-PNG-File.png" /> {auth?.user.weeklyContribution}</div>
              كغ تم بيعه هذا الأسبوع
            </div>
          </div>
          <div className="df-c g0">
            <div className='text df new'>مجموعة {data?.level?.levelName}</div>
            <div className='text df'> أحد مسئولي محافظة  {auth.user?.area} <CiLocationOn /></div>
          </div>
        </div>
      </div>
      <div className="df-c profile-details">
        <div className="df jc-sb">
          <Link to="edit" className="btn mt-5">تعديل المعلومات</Link>
          {auth?.user?.contact &&<div className="df jc-sa gap-8 !border-none media-list">
      {auth?.user?.contact.map((contact, index) => (
              <div key={`${contact.platform}-${contact.link}-${index}`} className="df-c g0 ai-center">
                <div className="bor">
                  <div className={`media-cont ${contact.platform}`}>
                    {platformIcons[contact.platform?.toLowerCase()] || null}
                  </div>
                </div>
                <a href={contact.link} target="_blank" rel="noopener noreferrer">
                  <span className="text-xs">{contact.platform}</span>
                </a>
              </div>
            ))}
</div>}
        </div>
  
 
    {level && stats && stats.data.totalSalesByCategoryForCurrentMonth && stats.data.totalHoneyGivenForCurrentMonth && (
      

          <div className="df sm-df-c flex-wrap pr">
        {level.level.targets.map((target) => {
          const matchingSalesItem = stats.data.totalSalesByCategoryForCurrentMonth.find(
            salesItem => salesItem.category._id === target.category._id
          );
          const percentage = (((matchingSalesItem ? matchingSalesItem.totalQuantity : 0) / target.kgToDeliver * 100).toFixed(2) < 100 ? ((matchingSalesItem ? matchingSalesItem.totalQuantity : 0) / target.kgToDeliver * 100).toFixed(2): 100 );

          return (
            <>

            {/* //////////// */}
            <div key={target._id} class="flex  sm-w-full !min-w-96 gap-5 p-4 bg-blue-100 rounded bonus">
            <div class="flex flex-shrink-0 items-center justify-center bg-blue-300 h-16 w-16 rounded">
              <img src={target.category.icon[0].url} className="w-12 h-12 object-cover" alt="" />
            </div>
            <div class="flex-grow flex flex-col ml-4">
              <span class="text-xl font-bold">{target.kgToDeliver} كغ {target.category.name}</span>
              <div class="flex items-center justify-between">
                <span class="text-gray-500">{(matchingSalesItem ? matchingSalesItem.totalQuantity : 0)}/{target.monthlyTarget} تم التوصيل</span>
              </div>
            </div>
            <div className={`radialBar`}>
                <CircularProgressbar value={percentage} text={`${(Math.round(percentage)> 100? 100 : Math.round(percentage))}%`} />
            </div>
          </div>
            </>
          );
        })}
      </div>
      )}




      </div>
    </div>
  );
};

export default ProfileHeader;